export const TOGGLE_PREVIEW = 'TOGGLE_PREVIEW'